import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Text } from '../../atoms/Text';
var GroupSubmenu = function GroupSubmenu(_ref) {
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    _ref$link = _ref.link,
    link = _ref$link === void 0 ? '' : _ref$link,
    subitems = _ref.subitems,
    mainCategory = _ref.mainCategory,
    tagManager = _ref.tagManager;
  var handleLinkClick = function handleLinkClick(e) {
    if (tagManager) {
      var tagManagerArgs = {
        dataLayer: {
          event: 'menuHeader',
          category: e
        }
      };
      tagManager(tagManagerArgs);
    }
  };
  return /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(LinkTitle, {
    type: "subtitle-md",
    tag: "a",
    href: link !== null && link.trim() !== '' ? link : null,
    onMouseDown: function onMouseDown() {
      return handleLinkClick("".concat(mainCategory, "_").concat(name));
    }
  }, name), subitems ? /*#__PURE__*/React.createElement(Subitems, null, subitems.map(function (si, index) {
    return /*#__PURE__*/React.createElement(Subitem, {
      key: index
    }, /*#__PURE__*/React.createElement(Text, {
      tag: "a",
      type: "label-md",
      href: si.URL,
      onMouseDown: function onMouseDown() {
        return handleLinkClick("".concat(mainCategory, "_").concat(name, "_").concat(si.Name));
      }
    }, si.Name));
  })) : null);
};
GroupSubmenu.propTypes = {
  name: PropTypes.string,
  link: PropTypes.string,
  subitems: PropTypes.array
};
export { GroupSubmenu };
var Group = styled.div.withConfig({
  displayName: "GroupSubmenu__Group",
  componentId: "sc-6gfmtt-0"
})(["box-sizing:border-box;margin-top:3px;padding:0 14px;width:32%;margin-bottom:24px;"]);
var LinkTitle = styled(Text).withConfig({
  displayName: "GroupSubmenu__LinkTitle",
  componentId: "sc-6gfmtt-1"
})(["color:", ";cursor:auto;text-decoration:none;letter-spacing:-0.2px;", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.black;
}, function (_ref3) {
  var href = _ref3.href;
  return href && css(["cursor:pointer;:hover{color:", ";}"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.blue600;
  });
});
var Subitems = styled.ul.withConfig({
  displayName: "GroupSubmenu__Subitems",
  componentId: "sc-6gfmtt-2"
})(["padding:0;margin:0;"]);
var Subitem = styled.li.withConfig({
  displayName: "GroupSubmenu__Subitem",
  componentId: "sc-6gfmtt-3"
})(["list-style:none;margin-top:8px;a{color:", ";text-decoration:none;:hover{color:", ";}}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.gray800;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.blue600;
});